import { createReducer } from '@reduxjs/toolkit'

import { UPDATE_ANONYMOUS_ID } from '../actions/segment'

const initialState = {
  anonymous_id: null
}

const segmentReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(UPDATE_ANONYMOUS_ID, (state, action) => {
      state.anonymous_id = action.payload
    })
})

export default segmentReducer
